<template>
  <v-card-actions
    v-if="value"
    class="d-flex justify-center align-center pa-0 loading-fixed"
    :style="styleObject"
  >
    <div :style="{ width: `${size}px`, height: `${size}px` }">
      <lottie :options="lottieOptions" :height="size" :width="size" />
    </div>
  </v-card-actions>
</template>

<script>
import Lottie from "vue-lottie";
import loadingIconLottie from "@/assets/images/icons/loading.json";

export default {
  components: {
    Lottie,
  },
  props: {
    value: Boolean,
    maxWidth: {
      type: [Number, String],
      default: 100,
    },
    size: {
      type: [Number, String],
      default: 100,
    },
  },
  data() {
    return {
      animationData: loadingIconLottie,
      tempSizeIcon: 100,
      lottieOptions: {
        animationData: loadingIconLottie,
        loop: true,
        autoplay: true,
      },
    };
  },
  computed: {
    styleObject() {
      return {
        maxWidth:
          typeof this.maxWidth === "number"
            ? `${this.maxWidth}px`
            : this.maxWidth,
      };
    },
  },
  async mounted() {
    try {
      // Load the JSON file
      // const response = await fetch(this.loadingIconLottie);
      this.animationData = loadingIconLottie;
    } catch (error) {
      console.error("Failed to load Lottie animation:", error);
      // Fallback animation if JSON file fails to load
      this.animationData = {
        v: "5.7.5",
        fr: 100,
        ip: 0,
        op: 160,
        w: 1024,
        h: 1024,
        ddd: 0,
        assets: [
          {
            id: "0",
            layers: [
              {
                ddd: 0,
                ind: 2,
                ty: 3,
                sr: 1,
                ks: {
                  p: { a: 0, k: [388, 894], ix: 2 },
                  a: { a: 0, k: [344, 522], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                ao: 0,
                ip: 0,
                op: 161,
                st: 0,
              },
              {
                ddd: 0,
                refId: "1",
                w: 771,
                h: 797,
                ind: 3,
                ty: 0,
                sr: 1,
                ks: {
                  p: { a: 0, k: [-46, -372], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                ao: 0,
                ip: 0,
                op: 161,
                st: 0,
                parent: 2,
              },
              {
                ddd: 0,
                ind: 4,
                ty: 3,
                sr: 1,
                ks: {
                  p: { a: 0, k: [646, 544], ix: 2 },
                  a: { a: 0, k: [423, 322], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                ao: 0,
                ip: 0,
                op: 161,
                st: 0,
              },
              {
                ddd: 0,
                refId: "2",
                w: 566,
                h: 566,
                ind: 5,
                ty: 0,
                sr: 1,
                ks: {
                  p: { a: 0, k: [-83, -83], ix: 2 },
                  o: {
                    a: 1,
                    k: [
                      {
                        t: 19,
                        s: [0],
                        i: { x: [0.75], y: [0.75] },
                        o: { x: [0.25], y: [0.25] },
                      },
                      {
                        t: 20,
                        s: [100],
                        i: { x: [0.75], y: [0.75] },
                        o: { x: [0.25], y: [0.25] },
                      },
                      {
                        t: 114,
                        s: [100],
                        i: { x: [0.75], y: [0.75] },
                        o: { x: [0.25], y: [0.25] },
                      },
                      { t: 115, s: [0] },
                    ],
                    ix: 2,
                  },
                },
                ao: 0,
                ip: 0,
                op: 161,
                st: 0,
                parent: 4,
              },
              {
                ddd: 0,
                ind: 6,
                ty: 3,
                sr: 1,
                ks: {
                  p: { a: 0, k: [593.43, 1077.43], ix: 2 },
                  a: { a: 0, k: [546.43, 663.43], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                ao: 0,
                ip: 0,
                op: 161,
                st: 0,
              },
              {
                ddd: 0,
                refId: "3",
                w: 1026,
                h: 1026,
                ind: 7,
                ty: 0,
                sr: 1,
                ks: {
                  p: { a: 0, k: [-49, -415], ix: 2 },
                  o: {
                    a: 1,
                    k: [
                      {
                        t: 39,
                        s: [0],
                        i: { x: [0.75], y: [0.75] },
                        o: { x: [0.25], y: [0.25] },
                      },
                      {
                        t: 40,
                        s: [100],
                        i: { x: [0.75], y: [0.75] },
                        o: { x: [0.25], y: [0.25] },
                      },
                      {
                        t: 134,
                        s: [100],
                        i: { x: [0.75], y: [0.75] },
                        o: { x: [0.25], y: [0.25] },
                      },
                      { t: 135, s: [0] },
                    ],
                    ix: 2,
                  },
                },
                ao: 0,
                ip: 0,
                op: 161,
                st: 0,
                parent: 6,
              },
              {
                ddd: 0,
                ind: 8,
                ty: 4,
                sr: 1,
                ks: { o: { a: 0, k: 100, ix: 2 } },
                ao: 0,
                shapes: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        d: 1,
                        ks: {
                          a: 0,
                          k: {
                            c: true,
                            v: [
                              [180, 55.38],
                              [180, 172],
                              [172, 180],
                              [8, 180],
                              [0, 172],
                              [0, 55.38],
                              [4, 48.45],
                              [86, 1.07],
                              [94, 1.07],
                              [176, 48.45],
                              [180, 55.38],
                            ],
                            i: [
                              [0, 0],
                              [0, 0],
                              [4.42, 0],
                              [0, 0],
                              [0, 4.42],
                              [0, 0],
                              [-2.48, 1.43],
                              [0, 0],
                              [-2.47, -1.43],
                              [0, 0],
                              [0, -2.86],
                            ],
                            o: [
                              [0, 0],
                              [0, 4.42],
                              [0, 0],
                              [-4.42, 0],
                              [0, 0],
                              [0, -2.86],
                              [0, 0],
                              [2.48, -1.43],
                              [0, 0],
                              [2.47, 1.43],
                              [0, 0],
                            ],
                          },
                        },
                      },
                      {
                        ty: "fl",
                        c: { a: 0, k: [0.56, 1, 0.134], ix: 2 },
                        o: { a: 0, k: 100, ix: 2 },
                        r: 1,
                        bm: 0,
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 1,
                          k: [
                            {
                              t: 60,
                              s: [762, 501],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            { t: 70, s: [762, 322] },
                          ],
                          ix: 2,
                        },
                        a: { a: 0, k: [90, 90], ix: 2 },
                        s: {
                          a: 1,
                          k: [
                            {
                              t: 60,
                              s: [10, 10],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            { t: 70, s: [100, 100] },
                          ],
                          ix: 2,
                        },
                        o: {
                          a: 1,
                          k: [
                            {
                              t: 59,
                              s: [0],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            { t: 60, s: [100] },
                          ],
                          ix: 2,
                        },
                      },
                    ],
                  },
                ],
                ip: 0,
                op: 161,
                st: 0,
              },
            ],
          },
          {
            id: "4",
            layers: [
              {
                ddd: 0,
                ind: 9,
                ty: 4,
                sr: 1,
                ks: {
                  p: { a: 0, k: [46, 372], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                ao: 0,
                shapes: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        d: 1,
                        ks: {
                          a: 0,
                          k: {
                            c: false,
                            v: [
                              [0, 0],
                              [0, 10],
                              [172, 182],
                              [344, 10],
                              [344, 6],
                            ],
                            i: [
                              [0, 0],
                              [0, 0],
                              [-94.99, 0],
                              [0, 94.99],
                              [0, 0],
                            ],
                            o: [
                              [0, 0],
                              [0, 94.99],
                              [94.99, 0],
                              [0, 0],
                              [0, 0],
                            ],
                          },
                        },
                      },
                      {
                        ty: "st",
                        c: { a: 0, k: [0.404, 0.051, 0.81], ix: 2 },
                        o: { a: 0, k: 100, ix: 2 },
                        w: { a: 0, k: 80, ix: 2 },
                        lc: 2,
                        lj: 1,
                        ml: 4,
                      },
                      {
                        ty: "tr",
                        p: { a: 0, k: [300, 131], ix: 2 },
                        a: { a: 0, k: [172, 91], ix: 2 },
                        o: { a: 0, k: 100, ix: 2 },
                      },
                    ],
                  },
                ],
                ip: 0,
                op: 161,
                st: 0,
              },
              {
                ddd: 0,
                ind: 10,
                ty: 4,
                sr: 1,
                ks: {
                  p: { a: 0, k: [46, 372], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                ao: 0,
                shapes: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [771, 797], ix: 2 },
                    p: { a: 0, k: [339.5, 26.5], ix: 2 },
                    r: { a: 0, k: 0, ix: 2 },
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [0, 0, 0], ix: 2 },
                    o: { a: 0, k: 0, ix: 2 },
                    r: 1,
                    bm: 0,
                  },
                ],
                ip: 0,
                op: 161,
                st: 0,
              },
            ],
          },
          {
            id: "1",
            layers: [
              {
                ddd: 0,
                ind: 11,
                ty: 4,
                sr: 1,
                ks: {
                  p: { a: 0, k: [46, 372], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                td: 1,
                ao: 0,
                shapes: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        d: 1,
                        ks: {
                          a: 0,
                          k: {
                            c: true,
                            v: [
                              [300, 0],
                              [0, 300],
                              [600, 300],
                              [300, 0],
                            ],
                            i: [
                              [0, 0],
                              [0, -165.689],
                              [0, 0],
                              [165.689, 0],
                            ],
                            o: [
                              [-165.689, 0],
                              [0, 0],
                              [0, -165.689],
                              [0, 0],
                            ],
                          },
                        },
                      },
                      {
                        ty: "fl",
                        c: { a: 0, k: [0.742, 0.742, 0.742], ix: 2 },
                        o: { a: 0, k: 100, ix: 2 },
                        r: 1,
                        bm: 0,
                      },
                      {
                        ty: "tr",
                        p: { a: 0, k: [300, 0], ix: 2 },
                        a: { a: 0, k: [300, 300], ix: 2 },
                        s: { a: 0, k: [100, 100], ix: 2 },
                        r: {
                          a: 1,
                          k: [
                            {
                              t: 0,
                              s: [0],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            {
                              t: 10,
                              s: [-90],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            {
                              t: 20,
                              s: [-180],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            {
                              t: 75,
                              s: [-180],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            {
                              t: 85,
                              s: [-270],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            { t: 95, s: [-360] },
                          ],
                          ix: 2,
                        },
                        o: { a: 0, k: 100, ix: 2 },
                      },
                    ],
                  },
                ],
                ip: 0,
                op: 161,
                st: 0,
              },
              {
                ddd: 0,
                refId: "4",
                w: 771,
                h: 797,
                ind: 3,
                ty: 0,
                sr: 1,
                ks: {
                  p: { a: 0, k: [339.5, 26.5], ix: 2 },
                  a: { a: 0, k: [339.5, 26.5], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                ao: 0,
                ip: 0,
                op: 161,
                st: 0,
                tt: 1,
              },
            ],
          },
          {
            id: "5",
            layers: [
              {
                ddd: 0,
                ind: 12,
                ty: 4,
                sr: 1,
                ks: {
                  p: { a: 0, k: [83, 83], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                ao: 0,
                shapes: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        d: 1,
                        ks: {
                          a: 0,
                          k: {
                            c: false,
                            v: [
                              [186, 130],
                              [186, 121.86],
                              [93, 0],
                              [0, 121.86],
                              [0, 130],
                            ],
                            i: [
                              [0, 0],
                              [0, 0],
                              [51.36, 0],
                              [0, -84.33],
                              [0, 0],
                            ],
                            o: [
                              [0, 0],
                              [0, -81.49],
                              [-51.36, 0],
                              [0, 0],
                              [0, 0],
                            ],
                          },
                        },
                      },
                      {
                        ty: "st",
                        c: { a: 0, k: [0.404, 0.051, 0.81], ix: 2 },
                        o: { a: 0, k: 100, ix: 2 },
                        w: { a: 0, k: 80, ix: 2 },
                        lc: 1,
                        lj: 1,
                        ml: 4,
                      },
                      {
                        ty: "tr",
                        p: { a: 0, k: [200, 135], ix: 2 },
                        a: { a: 0, k: [93, 65], ix: 2 },
                        o: { a: 0, k: 100, ix: 2 },
                      },
                    ],
                  },
                ],
                ip: 0,
                op: 161,
                st: 0,
              },
              {
                ddd: 0,
                ind: 13,
                ty: 4,
                sr: 1,
                ks: {
                  p: { a: 0, k: [83, 83], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                ao: 0,
                shapes: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [566, 566], ix: 2 },
                    p: { a: 0, k: [200, 200], ix: 2 },
                    r: { a: 0, k: 0, ix: 2 },
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [0, 0, 0], ix: 2 },
                    o: { a: 0, k: 0, ix: 2 },
                    r: 1,
                    bm: 0,
                  },
                ],
                ip: 0,
                op: 161,
                st: 0,
              },
            ],
          },
          {
            id: "2",
            layers: [
              {
                ddd: 0,
                ind: 14,
                ty: 4,
                sr: 1,
                ks: {
                  p: { a: 0, k: [83, 83], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                td: 1,
                ao: 0,
                shapes: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        d: 1,
                        ks: {
                          a: 0,
                          k: {
                            c: true,
                            v: [
                              [200, 0],
                              [0, 200],
                              [400, 200],
                              [200, 0],
                            ],
                            i: [
                              [0, 0],
                              [0, -110.459],
                              [0, 0],
                              [110.459, 0],
                            ],
                            o: [
                              [-110.459, 0],
                              [0, 0],
                              [0, -110.459],
                              [0, 0],
                            ],
                          },
                        },
                      },
                      {
                        ty: "fl",
                        c: { a: 0, k: [0.742, 0.742, 0.742], ix: 2 },
                        o: { a: 0, k: 100, ix: 2 },
                        r: 1,
                        bm: 0,
                      },
                      {
                        ty: "tr",
                        p: { a: 0, k: [200, 200], ix: 2 },
                        a: { a: 0, k: [200, 200], ix: 2 },
                        r: {
                          a: 1,
                          k: [
                            {
                              t: 20,
                              s: [180],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            {
                              t: 30,
                              s: [90],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            {
                              t: 40,
                              s: [0],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            {
                              t: 95,
                              s: [0],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            {
                              t: 105,
                              s: [-90],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            { t: 115, s: [-180] },
                          ],
                          ix: 2,
                        },
                        o: { a: 0, k: 100, ix: 2 },
                      },
                    ],
                  },
                ],
                ip: 0,
                op: 161,
                st: 0,
              },
              {
                ddd: 0,
                refId: "5",
                w: 566,
                h: 566,
                ind: 5,
                ty: 0,
                sr: 1,
                ks: {
                  p: { a: 0, k: [200, 200], ix: 2 },
                  a: { a: 0, k: [200, 200], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                ao: 0,
                ip: 0,
                op: 161,
                st: 0,
                tt: 1,
              },
            ],
          },
          {
            id: "6",
            layers: [
              {
                ddd: 0,
                ind: 15,
                ty: 4,
                sr: 1,
                ks: {
                  p: { a: 0, k: [49, 415], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                ao: 0,
                shapes: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        d: 1,
                        ks: {
                          a: 0,
                          k: {
                            c: false,
                            v: [
                              [432, 78],
                              [432, 82],
                              [216, 358],
                              [0, 82],
                              [0, 0],
                            ],
                            i: [
                              [0, 0],
                              [0, 0],
                              [119.29, 0],
                              [0, 152.43],
                              [0, 0],
                            ],
                            o: [
                              [0, 0],
                              [0, 152.43],
                              [-119.29, 0],
                              [0, 0],
                              [0, 0],
                            ],
                          },
                        },
                      },
                      {
                        ty: "st",
                        c: { a: 0, k: [0.404, 0.051, 0.81], ix: 2 },
                        o: { a: 0, k: 100, ix: 2 },
                        w: { a: 0, k: 80, ix: 2 },
                        lc: 1,
                        lj: 1,
                        ml: 4,
                      },
                      {
                        ty: "tr",
                        p: { a: 0, k: [499, 179], ix: 2 },
                        a: { a: 0, k: [216, 179], ix: 2 },
                        o: { a: 0, k: 100, ix: 2 },
                      },
                    ],
                  },
                ],
                ip: 0,
                op: 161,
                st: 0,
              },
              {
                ddd: 0,
                ind: 16,
                ty: 4,
                sr: 1,
                ks: {
                  p: { a: 0, k: [49, 415], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                ao: 0,
                shapes: [
                  {
                    ty: "rc",
                    d: 1,
                    s: { a: 0, k: [1026, 1026], ix: 2 },
                    p: { a: 0, k: [464, 98], ix: 2 },
                    r: { a: 0, k: 0, ix: 2 },
                  },
                  {
                    ty: "fl",
                    c: { a: 0, k: [0, 0, 0], ix: 2 },
                    o: { a: 0, k: 0, ix: 2 },
                    r: 1,
                    bm: 0,
                  },
                ],
                ip: 0,
                op: 161,
                st: 0,
              },
            ],
          },
          {
            id: "3",
            layers: [
              {
                ddd: 0,
                ind: 17,
                ty: 4,
                sr: 1,
                ks: {
                  p: { a: 0, k: [49, 415], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                td: 1,
                ao: 0,
                shapes: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        d: 1,
                        ks: {
                          a: 0,
                          k: {
                            c: true,
                            v: [
                              [499.43, 0],
                              [0, 498.87],
                              [998.86, 498.87],
                              [499.43, 0],
                            ],
                            i: [
                              [0, 0],
                              [0, -275.522],
                              [0, 0],
                              [275.834, 0],
                            ],
                            o: [
                              [-275.834, 0],
                              [0, 0],
                              [0, -275.522],
                              [0, 0],
                            ],
                          },
                        },
                      },
                      {
                        ty: "fl",
                        c: { a: 0, k: [0.742, 0.742, 0.742], ix: 2 },
                        o: { a: 0, k: 100, ix: 2 },
                        r: 1,
                        bm: 0,
                      },
                      {
                        ty: "tr",
                        p: { a: 0, k: [499.43, 0], ix: 2 },
                        a: { a: 0, k: [499.43, 498.87], ix: 2 },
                        s: { a: 0, k: [100, 100], ix: 2 },
                        r: {
                          a: 1,
                          k: [
                            {
                              t: 0,
                              s: [-432],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            {
                              t: 40,
                              s: [-360],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            {
                              t: 50,
                              s: [-450],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            {
                              t: 60,
                              s: [-540],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            {
                              t: 115,
                              s: [-540],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            {
                              t: 125,
                              s: [-630],
                              i: { x: [0.75], y: [0.75] },
                              o: { x: [0.25], y: [0.25] },
                            },
                            { t: 135, s: [-720] },
                          ],
                          ix: 2,
                        },
                        o: { a: 0, k: 100, ix: 2 },
                      },
                    ],
                  },
                ],
                ip: 0,
                op: 161,
                st: 0,
              },
              {
                ddd: 0,
                refId: "6",
                w: 1026,
                h: 1026,
                ind: 7,
                ty: 0,
                sr: 1,
                ks: {
                  p: { a: 0, k: [464, 98], ix: 2 },
                  a: { a: 0, k: [464, 98], ix: 2 },
                  o: { a: 0, k: 100, ix: 2 },
                },
                ao: 0,
                ip: 0,
                op: 161,
                st: 0,
                tt: 1,
              },
            ],
          },
        ],
        layers: [
          {
            ddd: 0,
            refId: "0",
            w: 1024,
            h: 1024,
            ind: 1,
            ty: 0,
            nm: "lottielab.com",
            sr: 1,
            ks: {
              p: { a: 0, k: [544.93, 567.43], ix: 2 },
              a: { a: 0, k: [544.93, 567.43], ix: 2 },
              o: { a: 0, k: 100, ix: 2 },
            },
            ao: 0,
            ip: 0,
            op: 161,
            st: 0,
          },
        ],
      };
    }
  },
};
</script>

<style scoped>
.loading-fixed {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background: rgba(255, 255, 255, 0.8);
}

.d-flex {
  display: flex;
}

.justify-center {
  justify-content: center;
}

.align-center {
  align-items: center;
}
</style>
